var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 123,
    viewBox: "0 0 238 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03125 13.7385L13.588 12.1794L30.4746 2.30518L52.9902 30.3688H76.8047L104.083 20.4945L138.722 23.093L159.939 4.90366",
    stroke: "white",
    strokeWidth: 1.14674,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9478 12.2787L1.37988 13.849V114.333C1.37988 118.752 4.96161 122.333 9.37989 122.333H229C233.418 122.333 237 118.752 237 114.333V4.42723L204.987 23.2708L180.049 21.7341L153.249 20.3648L113.428 30.5989H77.8727L44.9184 2.3335L19.9478 12.2787Z",
    fill: "url(#paint0_linear_905_3328)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81278,
    cy: 13.1468,
    r: 1.81278,
    fill: "#00086D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8128,
    cy: 11.6463,
    r: 1.81278,
    fill: "#00086D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.8128,
    cy: 2.47928,
    r: 1.81278,
    fill: "#00086D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.8128,
    cy: 30.8128,
    r: 1.81278,
    fill: "#00086D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.813,
    cy: 4.81278,
    r: 1.81278,
    fill: "#00086D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.813,
    cy: 30.8128,
    r: 1.81278,
    fill: "#00086D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.813,
    cy: 20.8128,
    r: 1.81278,
    fill: "#00086D"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.813,
    cy: 22.8128,
    r: 1.81278,
    fill: "#00086D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_905_3328",
    x1: 119.19,
    y1: -5.1665,
    x2: 114.195,
    y2: 89.6879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E18AB",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACD2",
    stopOpacity: 0.05
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartGraph);
export default __webpack_public_path__ + "static/media/ChartGraph.ec2f14829101353a2cc0a0cd93c7cbdc.svg";
export { ForwardRef as ReactComponent };